import { useState, useEffect } from 'react';

export default function ServiceAreas() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 768);
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  const containerHeight = isMobile ? 330 : 460;
  const iframeHeight = isMobile ? 380 : 545;
  const cropTop = isMobile ? -50 : -85;

  return (
    <section id="zonas" className="py-24 bg-[#F4F1EC]">
      <div className="max-w-6xl mx-auto px-6 lg:px-12">
        {/* Título */}
        <div className="mb-16">
          <h2 className="text-5xl lg:text-6xl font-heading font-bold text-[#1A1A2E] leading-tight mb-6">
            Cobertura en Saltillo<br />
            y zona metropolitana de Monterrey
          </h2>
          <p className="text-xl text-[#1A1A2E]/70 max-w-3xl">
            Empresa con base en Saltillo, Coahuila, con cobertura regional en Monterrey y su zona metropolitana para proyectos de construcción, mantenimiento e instalaciones
          </p>
        </div>

        {/* Mapa Google My Maps */}
        <div
          className="w-full rounded-2xl mb-12"
          style={{ height: `${containerHeight}px`, overflow: 'hidden', position: 'relative' }}
        >
          <iframe
            src="https://www.google.com/maps/d/embed?mid=17kHUPGvxlUQeqE23hERNVP8oYwIJKd4&ehbc=2E312F"
            width="100%"
            height={iframeHeight}
            style={{
              border: 0,
              display: 'block',
              marginTop: `${cropTop}px`,
            }}
            allowFullScreen
            loading="lazy"
            title="Zonas de Servicio"
          />
        </div>

        {/* Tarjetas de contacto rápido */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Saltillo */}
          <div className="bg-white rounded-xl shadow-md p-8 hover:shadow-xl transition-shadow">
            <div className="flex items-start gap-4 mb-4">
              <div className="w-12 h-12 bg-[#C9A86A]/10 rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-map-pin-2-fill text-[#C9A86A] text-xl"></i>
              </div>
              <div>
                <div className="flex items-center gap-3 mb-2">
                  <h3 className="text-2xl font-bold text-[#1A1A2E]">Saltillo y Zona</h3>
                  <span className="px-2.5 py-0.5 bg-[#C9A86A]/15 text-[#9B7D45] text-xs font-semibold rounded-full whitespace-nowrap">Sede principal</span>
                </div>
                <p className="text-[#7D7D7D] mb-4">
                  Saltillo, Arteaga, Ramos Arizpe y municipios aledaños
                </p>
                <div className="space-y-2">
                  <a
                    href="tel:+528447098387"
                    className="flex items-center gap-2 text-[#1A1A2E] hover:text-[#C9A86A] transition-colors"
                  >
                    <i className="ri-phone-fill"></i>
                    <span className="font-semibold">(844) 709-8387</span>
                  </a>
                  <a
                    href="https://wa.me/528447098387"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 px-5 py-3 bg-[#25D366] text-white rounded-lg font-semibold hover:bg-[#1FA855] transition-colors whitespace-nowrap"
                  >
                    <i className="ri-whatsapp-fill text-xl"></i>
                    Chatear por WhatsApp
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Monterrey */}
          <div className="bg-white rounded-xl shadow-md p-8 hover:shadow-xl transition-shadow">
            <div className="flex items-start gap-4 mb-4">
              <div className="w-12 h-12 bg-[#1A1A2E]/10 rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-route-line text-[#1A1A2E] text-xl"></i>
              </div>
              <div>
                <div className="flex items-center gap-3 mb-2">
                  <h3 className="text-2xl font-bold text-[#1A1A2E]">Monterrey y ZM</h3>
                  <span className="px-2.5 py-0.5 bg-[#1A1A2E]/10 text-[#1A1A2E] text-xs font-semibold rounded-full whitespace-nowrap">Servicio bajo agenda</span>
                </div>
                <p className="text-[#7D7D7D] mb-4">
                  Monterrey, San Pedro, García, Santa Catarina y área metropolitana
                </p>
                <div className="space-y-2">
                  <a
                    href="tel:+528120789333"
                    className="flex items-center gap-2 text-[#1A1A2E] hover:text-[#C9A86A] transition-colors"
                  >
                    <i className="ri-phone-fill"></i>
                    <span className="font-semibold">(812) 078-9333</span>
                  </a>
                  <a
                    href="https://wa.me/528120789333"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 px-5 py-3 bg-[#25D366] text-white rounded-lg font-semibold hover:bg-[#1FA855] transition-colors whitespace-nowrap"
                  >
                    <i className="ri-whatsapp-fill text-xl"></i>
                    Chatear por WhatsApp
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}